import React from "react";
import "./Certificate.css";

const Certificate = () => {
  return (
    <div className="Certificate">
      <div className="col_header">
        <h5 className="col_title">Unlock Global Recognition</h5>
        <p className="col_text">
          Experience world-class education through our partnership with renowned
          institutions via edX
        </p>
      </div>
      <div className="row align-items-center me-0 ms-0">
        <div className="col-lg-6">
          <div className="container">
            <div className="top_img_div">
              <div className="man_img_holder">
                <img
                  src="/assets/edtech_assets/images/university/certificate/man.png"
                  className="man_img"
                />
              </div>
              <div className="sample_cerificate_div">
                <p className="title">Sample Certificate</p>
                <div className="certificate_img_holder">
                  <img
                    src="/assets/edtech_assets/images/university/certificate/certificates.png"
                    className="img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="red_box">
            <div className="container">
              <div className="row1_div">
                <div className="university_holder">
                  <img
                    src="/assets/edtech_assets/images/university/certificate/img1.png"
                    className="img"
                  />
                </div>
                <div className="university_holder">
                  <img
                    src="/assets/edtech_assets/images/university/certificate/img2.png"
                    className="img"
                  />
                </div>
                <div className="university_holder">
                  <img
                    src="/assets/edtech_assets/images/university/certificate/img3.png"
                    className="img"
                  />
                </div>
              </div>
              <div className="row2_div">
                <div className="university_holder">
                  <img
                    src="/assets/edtech_assets/images/university/certificate/img4.png"
                    className="img"
                  />
                </div>
                <div className="university_holder">
                  <img
                    src="/assets/edtech_assets/images/university/certificate/img5.png"
                    className="img"
                  />
                </div>
              </div>

              <p className="white_text">and many more...</p>

              <p className="yellow_text">1000+ CERTIFICATES</p>

              <p className="choose_text">to Choose From.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
